



































































































































































































































































































































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import { IAddChannel, IChannel } from "@/@types/channels/channels";
import { IContentType } from "@/@types/channels/content-type";
import { channelTypes } from "@/config/channels/channel-types.config.json";

import BSwitch from "../../app/switchs/b-switch.vue";

import {
  required,
  numeric,
  maxLength,
  minValue,
  maxValue,
} from "vuelidate/lib/validators";
import {
  ipBroadcastTypes,
  languages,
  channelType,
  rfBroadcastTypes,
} from "@/config/channels/channel-types.config.json";

@Component({
  components: { BSwitch },
  mixins: [validationMixin],
  validations: {
    frequency: { required, numeric },
    programnumber: {
      required,
      numeric,
      maxValue: maxValue(65535),
      minValue: minValue(0),
    },
    symbolRate: {
      required,
      numeric,
      maxValue: maxValue(4294967295),
      minValue: minValue(0),
    },

    name: { required, maxLength: maxLength(100) },
    sortOrder: { numeric, minValue: minValue(0) },
    language: {},
    contentType: {},
  },
})
export default class AddChannelFormDVBT extends Vue {
  @Prop({ type: Object, default: null }) channel!: IChannel;
  @Prop({ type: Array, default: () => [] }) contentTypes!: Array<IContentType>;
  @Prop({ type: String, default: null }) formType!: string;
  @Prop({ type: String, default: "tv" }) activeType!: string;
  frequency = 0;
  programnumber = 0;
  symbolRate = 0;
  selectedChannelType = channelType[1].id;

  name = "";
  sortOrder = 0;
  language = "";
  contentType = "";
  posterName = "";
  showChannel = false;
  logicalNumberOnLinkedTv: number | null = null;

  ipBroadcastTypes = ipBroadcastTypes;
  languages = languages;

  get channelLanguage(): string {
    const language = this.languages.find((l) => l.lang == this.language);
    return language
      ? language.name
      : String(this.$i18n.t("ChannelsPage.form.langusge.no-type"));
  }

  get contentTypeName(): string {
    const type = this.contentTypes.find((el) => el._id == this.contentType);
    return type
      ? this.$getLocale(type.name)
      : String(this.$i18n.t("ChannelsPage.form.contentType.no-type"));
  }

  get rfBroadcastType(): number {
    const item = rfBroadcastTypes.find((rf) => rf.abriviate == this.formType);
    return item ? item.id : 0;
  }

  get type(): number {
    const i = channelTypes.findIndex((t) => t == this.activeType);
    return i < 0 ? 1 : i + 1;
  }

  get ch(): Partial<IAddChannel> {
    return {
      data: {
        channelType: this.selectedChannelType,
        frequency: this.frequency,
        programNumber: this.programnumber,
        rfBroadcastType: this.rfBroadcastType,
        symbolRate: this.symbolRate,
      },
      _id: undefined,
      image: this.posterName,
      name: this.name,
      show: this.showChannel,
      sort_order: this.sortOrder,
      language: this.language,
      type: this.channel ? this.channel.type : this.type,
      content_type: this.contentType,
      logical_number_on_linked_tv: this.logicalNumberOnLinkedTv ?? 0,
    };
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    if (this.$v.$invalid) {
      console.log("invalid");

      this.$v.$touch();
      return;
    }

    this.$emit("update", this.ch);
  }

  onReset(): void {
    this.frequency = 0;
    this.programnumber = 0;
    this.symbolRate = 0;
    this.selectedChannelType = channelType[1].id;
    this.name = "";
    this.sortOrder = 0;
    this.language = "";
    this.contentType = "";
    this.posterName = "";
    this.showChannel = false;
    this.logicalNumberOnLinkedTv = null;
  }

  @Watch("name")
  @Watch("posterName")
  updateDemo(): void {
    this.$emit("updateDemo", this.name, this.posterName);
  }

  @Watch("channel")
  valueDistribution(): void {
    if (!this.channel || !this.channel.data) return;
    this.frequency = this.channel.data.frequency;
    this.programnumber = this.channel.data.programNumber;
    this.symbolRate = this.channel.data.symbolRate;
    this.name = this.channel.name;
    this.sortOrder = this.channel.sort_order;
    this.language = this.channel.language;
    this.contentType = this.channel.content_type;
    this.posterName = this.channel.image;
    this.showChannel = this.channel.show;
    this.logicalNumberOnLinkedTv =
      this.channel.logical_number_on_linked_tv ?? null;
  }

  mounted(): void {
    this.valueDistribution();
  }
}
